import React from "react";
import { OrderHistory, HistoryColumn } from "../OrderHistory/OrderHistory";
import { SalesOrderApi } from "../../../api/OrderManagement/SalesOrderApi";
import {
  SalesOrderHistoryEntry,
  SalesOrderPartHistoryEntry,
} from "../../../@types/DRO/SalesOrderResponse";

const orderColumns: HistoryColumn<SalesOrderHistoryEntry>[] = [
  { key: "status", label: "Status" },
  {
    key: "salesPrice",
    label: "Sales Price",
    render: (row) => `₹ ${row.salesPrice?.toFixed(2) ?? "0.00"}`,
  },
  { key: "action", label: "Action" },
  { key: "updatedBy", label: "Updated By" },
  { key: "updatedAt", label: "Updated At" },
];

const partColumns: HistoryColumn<SalesOrderPartHistoryEntry>[] = [
  { key: "partName", label: "Part Name" },
  { key: "action", label: "Action" },
  { key: "quantity", label: "Quantity" },
  {
    key: "price",
    label: "Price",
    render: (row) => `₹ ${row.price?.toFixed(2) ?? "0.00"}`,
  },
  { key: "updatedBy", label: "Updated By" },
  { key: "updatedAt", label: "Updated At" },
];

interface Props {
  salesOrderId: number;
  variant?: "inline" | "dialog";
  open?: boolean;
  onClose?: () => void;
}

export const SalesOrderHistory: React.FC<Props> = ({
  salesOrderId,
  variant = "inline",
  open = false,
  onClose,
}) => (
  <OrderHistory
    title="Sales Order History"
    variant={variant}
    open={open}
    onClose={onClose}
    orderColumns={orderColumns}
    partColumns={partColumns}
    fetchHistory={async () => {
      const res = await SalesOrderApi.api.getSalesOrderHistory(salesOrderId);
      return res.data;
    }}
  />
);